/* Bontu theme JS — geport van de custom site, met Shopify-form wiring.
   Alle interacties: kleur-slider, FAQ, veiligheid-tabs, specs-modal,
   benefits-marquee, features-carousel, mobiel menu, drawers + detail-modals,
   proefrit/financiering/contact forms (lead-handler + Google reCAPTCHA), nieuwsbrief (Shopify hCaptcha), scroll-spy. */
(function () {
  "use strict";

  /* ── i18n voor JS-meldingen (Liquid-teksten lopen via | t; dit dekt de dynamische JS-strings).
        Taal komt uit window.BONTU_LANG (in theme.liquid gezet vanuit localization.language.iso_code). ── */
  var LANG = (window.BONTU_LANG || 'nl').slice(0, 2);
  var I18N = {
    nl: {
      send: 'Versturen...', fillName: 'Vul je naam en e-mailadres in.', fillEmail: 'Vul een geldig e-mailadres in.',
      error: 'Er ging iets mis. Mail ons op info@bontu.nl.', subThanks: 'Bedankt voor je inschrijving!',
      contactThanks: 'Bedankt! We nemen snel contact met je op.', captchaFail: 'Vink eerst "Ik ben geen robot" aan.',
      buy: 'Bestel nu', sold: 'Uitverkocht', unavail: 'Niet beschikbaar',
      safetyDesc: [
        "Verstevigde stalen constructie die de cabine beschermt bij een botsing. Een stevige kern voor een rustiger rijgevoel.",
        "Extra bescherming om het risico op letsel bij een frontale botsing te verkleinen. Meer zekerheid in het dagelijks verkeer.",
        "Frontairbag voor de bestuurder die het risico op letsel bij een frontale botsing verkleint. Meer veiligheid bij elke rit.",
        "Antiblokkeerremsysteem dat voorkomt dat de wielen blokkeren bij hard remmen. Meer controle bij weinig grip.",
        "Elektronische remkrachtverdeling die de remkracht verdeelt tussen voor- en achterwielen. Stabieler remmen onder wisselende omstandigheden.",
        "Voorkomt dat Bontu achteruit rolt bij het wegrijden op een helling. Meer controle, ook op schuine straten.",
        "Standaard ISOFIX-bevestigingspunten voor het veilig vastklikken van een kinderzitje. Snel, stevig en zonder gedoe."
      ]
    },
    es: {
      send: 'Enviando...', fillName: 'Introduce tu nombre y tu correo electrónico.', fillEmail: 'Introduce un correo electrónico válido.',
      error: 'Algo salió mal. Escríbenos a info@bontu.nl.', subThanks: '¡Gracias por suscribirte!',
      contactThanks: '¡Gracias! Nos pondremos en contacto contigo pronto.', captchaFail: 'Marca primero "No soy un robot".',
      buy: 'Compra ahora', sold: 'Agotado', unavail: 'No disponible',
      safetyDesc: [
        "Estructura de acero reforzada que protege el habitáculo en caso de colisión. Un núcleo sólido para una conducción más tranquila.",
        "Protección adicional para reducir el riesgo de lesiones en una colisión frontal. Más seguridad en el tráfico diario.",
        "Airbag frontal para el conductor que reduce el riesgo de lesiones en una colisión frontal. Más seguridad en cada trayecto.",
        "Sistema antibloqueo de frenos que evita que las ruedas se bloqueen al frenar con fuerza. Más control con poca adherencia.",
        "Reparto electrónico de la fuerza de frenada entre las ruedas delanteras y traseras. Frenada más estable en condiciones cambiantes.",
        "Evita que Bontu ruede hacia atrás al arrancar en una pendiente. Más control, también en calles inclinadas.",
        "Anclajes ISOFIX de serie para fijar con seguridad una silla infantil. Rápido, firme y sin complicaciones."
      ]
    }
  };
  function T(k) { return (I18N[LANG] && I18N[LANG][k] != null) ? I18N[LANG][k] : I18N.nl[k]; }

  /* ── Spam-captcha (Google reCAPTCHA v2, "Ik ben geen robot") + lead-handler ──
        Vinkje komt boven de verzendknop; de handler checkt het token bij Google en
        weigert aanvragen zonder geldige captcha. Site key staat in layout/theme.liquid. */
  var LEAD_API = 'https://bentuev.vercel.app/api/lead';
  var capQueue = [];
  // donkere achtergrond (navy formulierblok) -> donker vinkje
  function onDark(el) {
    for (; el && el.nodeType === 1; el = el.parentNode) {
      var m = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
      if (m && (m.length < 4 || +m[3] > 0.5)) return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) < 128;
    }
    return false;
  }
  // vaste 304px van Google: op smalle formulieren meeschalen zodat hij niet uit het blok steekt
  function fitCaptcha(box) {
    var p = box.parentNode, cs = p && getComputedStyle(p);
    var w = p ? p.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) : 0;
    var s = (w && w < 304) ? w / 304 : 1;
    box.style.transform = s < 1 ? 'scale(' + s + ')' : '';
    box.style.height = s < 1 ? Math.ceil(78 * s) + 'px' : '';
  }
  function renderCaptcha(box) {
    if (box.getAttribute('data-wid') != null) return;
    box.setAttribute('data-wid', window.grecaptcha.render(box, { sitekey: window.BONTU_RECAPTCHA_KEY, theme: onDark(box.parentNode) ? 'dark' : 'light' }));
    fitCaptcha(box);
  }
  function fitAll() { [].forEach.call(document.querySelectorAll('.bcap'), fitCaptcha); }
  window.addEventListener('resize', fitAll);
  document.addEventListener('click', function () { setTimeout(fitAll, 50); }, true); // drawers/modals openen
  window.bontuRecaptchaReady = function () { capQueue.forEach(renderCaptcha); capQueue = []; };
  function addCaptcha(form) {
    if (!form || form.querySelector('.bcap') || !window.BONTU_RECAPTCHA_KEY) return;
    var box = document.createElement('div');
    box.className = 'bcap';
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.parentNode.insertBefore(box, btn); else form.appendChild(box);
    if (window.grecaptcha && window.grecaptcha.render) renderCaptcha(box); else capQueue.push(box);
  }
  function captchaWid(form) { var b = form.querySelector('.bcap'); return b ? b.getAttribute('data-wid') : null; }
  // -> Promise<token>; zonder aangevinkte captcha -> reject('captcha')
  function captchaPayload(form) {
    var wid = captchaWid(form);
    var token = (wid != null && window.grecaptcha) ? window.grecaptcha.getResponse(+wid) : '';
    return token ? Promise.resolve(token) : Promise.reject(new Error('captcha'));
  }
  function resetCaptcha(form) { var wid = captchaWid(form); if (wid != null && window.grecaptcha) window.grecaptcha.reset(+wid); }
  // captcha-token -> lead-handler; resolve bij ok, reject ('captcha' of 'http') anders
  function sendLead(form, data) {
    return captchaPayload(form).then(function (token) {
      data.recaptcha = token; data.page = location.pathname;
      return fetch(LEAD_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    }).then(function (r) {
      if (r.ok) return r.json();
      throw new Error(r.status === 403 ? 'captcha' : 'http');
    });
  }
  window.BONTU_addCaptcha = addCaptcha;
  window.BONTU_sendLead = sendLead;
  window.BONTU_resetCaptcha = resetCaptcha;

  /* ── Kleur-slider ── */
  (function () {
    var slides = [].slice.call(document.querySelectorAll('.cslide'));
    var dots = [].slice.call(document.querySelectorAll('.cdot'));
    if (!slides.length) return;
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    var prev = document.querySelector('.carrow.prev'), next = document.querySelector('.carrow.next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-i')); }); });
  })();

  /* ── FAQ accordion ── */
  (function () {
    document.querySelectorAll('#faqList .faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        document.querySelectorAll('#faqList .faq-item.open').forEach(function (o) {
          o.classList.remove('open'); o.querySelector('.faq-a').style.maxHeight = null;
        });
        if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  })();

  /* ── Veiligheid tabs (beelden via window.BONTU_SAFETY_IMGS) ── */
  (function () {
    var IMGS = window.BONTU_SAFETY_IMGS || [];
    var DESC = T('safetyDesc');
    var tabs = [].slice.call(document.querySelectorAll('#safetyTabs .stab'));
    var img = document.getElementById('safetyImg'), desc = document.getElementById('safetyDesc');
    if (!tabs.length || !img) return;
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-i');
        tabs.forEach(function (x) { x.classList.remove('active'); }); t.classList.add('active');
        if (IMGS[i]) img.src = IMGS[i];
        img.alt = t.textContent; desc.textContent = DESC[i];
      });
    });
  })();

  /* ── Specs modal ── */
  (function () {
    var modal = document.getElementById('specsModal'), open = document.getElementById('openSpecs');
    if (!modal || !open) return;
    function show() { modal.classList.add('open'); modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function hide() { modal.classList.remove('open'); modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    open.addEventListener('click', show);
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', hide); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) hide(); });
  })();

  /* ── Benefits marquee + features-carousel voortgangsbalk ── */
  (function () {
    var track = document.querySelector('.benefits-track');
    if (track && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
      track.innerHTML += track.innerHTML;
    }
    var car = document.getElementById('featCarousel'), thumb = document.getElementById('featThumb'), t = document.getElementById('featTrack');
    if (car && thumb && t) {
      function upd() {
        var w = Math.max(12, car.clientWidth / car.scrollWidth * 100);
        thumb.style.width = w + '%';
        var max = car.scrollWidth - car.clientWidth;
        var p = max > 0 ? car.scrollLeft / max : 0;
        thumb.style.left = (p * (100 - w)) + '%';
      }
      car.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
      var drag = false;
      function seek(x) { var r = t.getBoundingClientRect(); var p = Math.min(1, Math.max(0, (x - r.left) / r.width)); car.scrollLeft = p * (car.scrollWidth - car.clientWidth); }
      t.addEventListener('pointerdown', function (e) { drag = true; t.setPointerCapture(e.pointerId); seek(e.clientX); });
      t.addEventListener('pointermove', function (e) { if (drag) seek(e.clientX); });
      t.addEventListener('pointerup', function () { drag = false; });
      t.addEventListener('pointercancel', function () { drag = false; });
      var cdrag = false, startX = 0, startL = 0, moved = false;
      car.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; moved = false; if (e.target.closest('.fplus')) return; cdrag = true; startX = e.clientX; startL = car.scrollLeft; car.setPointerCapture(e.pointerId); });
      car.addEventListener('pointermove', function (e) { if (!cdrag) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) { moved = true; car.classList.add('dragging'); } car.scrollLeft = startL - dx; });
      function endDrag() { cdrag = false; car.classList.remove('dragging'); }
      car.addEventListener('pointerup', endDrag);
      car.addEventListener('pointercancel', endDrag);
      car.addEventListener('click', function (e) { if (moved && !e.target.closest('.fplus')) { e.preventDefault(); e.stopPropagation(); } }, true);
    }
  })();

  /* ── Mobiel menu ── */
  (function () {
    var mm = document.getElementById('mobMenu'), t = document.getElementById('navToggle'), x = document.getElementById('mobClose');
    if (!mm) return;
    function open() { mm.classList.add('open'); mm.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { mm.classList.remove('open'); mm.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    if (t) t.addEventListener('click', open);
    if (x) x.addEventListener('click', close);
    mm.addEventListener('click', function (e) { if (e.target === mm) close(); });
    mm.querySelectorAll('a.ml').forEach(function (a) { a.addEventListener('click', close); });
  })();

  /* ── Drawers (proefrit + financiering) + detail-modals + forms ── */
  (function () {
    function opener(drawer) {
      return function () {
        drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
        var cfgBox = drawer.querySelector('.dcfg');
        if (cfgBox && typeof window.__bentuConfig === 'function') {
          var c = window.__bentuConfig();
          if (c) { cfgBox.textContent = c; cfgBox.style.display = 'block'; }
        }
        drawer.scrollTop = 0;
      };
    }
    function closeAll() {
      document.querySelectorAll('.drawer.open,.imodal.open').forEach(function (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
      document.body.style.overflow = '';
    }
    function preloadModal(m) {
      if (!m || m.__pl) return; m.__pl = true;
      m.querySelectorAll('img').forEach(function (im) {
        im.loading = 'eager';
        var s = im.getAttribute('src'); if (s) { var p = new Image(); p.src = s; }
      });
    }
    document.querySelectorAll('[data-imodal]').forEach(function (el) {
      var mid = el.getAttribute('data-imodal');
      var warm = function () { preloadModal(document.getElementById(mid)); };
      el.addEventListener('pointerenter', warm);
      el.addEventListener('touchstart', warm, { passive: true });
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var m = document.getElementById(mid);
        if (m) { preloadModal(m); m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; m.scrollTop = 0; }
      });
    });
    document.querySelectorAll('[data-iclose]').forEach(function (el) { el.addEventListener('click', closeAll); });
    var dp = document.getElementById('drawerProefrit'), df = document.getElementById('drawerFinanciering');
    var openP = dp ? opener(dp) : null, openF = df ? opener(df) : null;
    function fromMenu(fn) { return function (e) { e.preventDefault(); var mm = document.getElementById('mobMenu'); if (mm && mm.classList.contains('open')) { mm.classList.remove('open'); mm.setAttribute('aria-hidden', 'true'); } fn(); }; }
    document.querySelectorAll('[data-proefrit]').forEach(function (el) { if (openP) el.addEventListener('click', fromMenu(openP)); });
    document.querySelectorAll('[data-financiering]').forEach(function (el) { if (openF) el.addEventListener('click', fromMenu(openF)); });
    document.querySelectorAll('[data-dclose]').forEach(function (el) { el.addEventListener('click', closeAll); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    window.__bentuCloseDrawers = closeAll;

    document.querySelectorAll('.dlocs').forEach(function (group) {
      group.querySelectorAll('.dloc').forEach(function (loc) {
        loc.addEventListener('click', function () {
          group.querySelectorAll('.dloc').forEach(function (l) { l.classList.remove('sel'); });
          loc.classList.add('sel');
        });
      });
    });

    /* Shopify contact-submit + redirect naar bedankt-pagina (= Meta-conversie) */
    function wireForm(formId, type, redirect, msgId) {
      var form = document.getElementById(formId); if (!form) return;
      var msg = document.getElementById(msgId);
      var btn = form.querySelector('.dbtn');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        msg.className = 'dmsg'; msg.textContent = '';
        var fd = new FormData(form);
        if ((fd.get('company') || '').trim()) { return; } // honeypot
        var sel = form.querySelector('.dloc.sel');
        var name = (fd.get('name') || '').trim(), email = (fd.get('email') || '').trim();
        var phone = (fd.get('phone') || '').trim(), message = (fd.get('message') || '').trim();
        var loc = sel ? sel.getAttribute('data-loc') : '';
        var cfgBox = form.querySelector('.dcfg');
        var cfg = (cfgBox && cfgBox.style.display !== 'none') ? cfgBox.textContent : '';
        if (!name || !email) { msg.className = 'dmsg err'; msg.textContent = T('fillName'); return; }
        btn.disabled = true; var orig = btn.textContent; btn.textContent = T('send');
        // lead-handler: captcha-check + per-locatie dealer-mail + klant-bevestiging, daarna bedankt-pagina (= conversie)
        sendLead(form, { type: type, name: name, email: email, phone: phone, message: message, location: loc, config: cfg })
          .then(function () { window.location.href = redirect; })
          .catch(function (err) {
            msg.className = 'dmsg err'; msg.textContent = (err && err.message !== 'http') ? T('captchaFail') : T('error');
            btn.disabled = false; btn.textContent = orig; resetCaptcha(form);
          });
      });
      addCaptcha(form);
    }
    wireForm('formProefrit', 'Proefrit', '/pages/bedankt', 'msgProefrit');
    wireForm('formFinanciering', 'Financiering', '/pages/aanvraag-ontvangen', 'msgFinanciering');
  })();

  /* ── Nieuwsbrief: native Shopify customer-form, beschermd door Shopify's eigen hCaptcha ──
        (een fetch naar /contact weigert Shopify met "Missing CAPTCHA token"; een echte
        form-submit met form_type=customer pakt Shopify's captcha automatisch op.) */
  (function () {
    var f = document.getElementById('newsForm'), note = document.getElementById('newsNote');
    if (!f) return;
    var input = f.querySelector('input[type=email]');
    f.setAttribute('method', 'post');
    f.setAttribute('action', '/contact#newsForm');
    f.setAttribute('accept-charset', 'UTF-8');
    [['form_type', 'customer'], ['utf8', '\u2713'], ['contact[tags]', 'newsletter']].forEach(function (kv) {
      var h = document.createElement('input'); h.type = 'hidden'; h.name = kv[0]; h.value = kv[1]; f.appendChild(h);
    });
    if (input) input.name = 'contact[email]';
    f.addEventListener('submit', function (e) {
      var email = ((input && input.value) || '').trim();
      if (!email || email.indexOf('@') < 0) { e.preventDefault(); e.stopImmediatePropagation(); note.textContent = T('fillEmail'); }
    }, true);
    if (/customer_posted=true/.test(location.search)) {
      note.textContent = T('subThanks');
      setTimeout(function () { f.scrollIntoView({ block: 'center' }); }, 300);
    }
  })();

  /* ── Scroll-spy nav ── */
  (function () {
    var links = [].slice.call(document.querySelectorAll('.links a'));
    var map = {}; links.forEach(function (a) { var h = a.getAttribute('href'); if (h && h[0] === '#') map[h.slice(1)] = a; });
    var ids = Object.keys(map); if (!ids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { links.forEach(function (a) { a.classList.remove('active'); }); if (map[en.target.id]) map[en.target.id].classList.add('active'); }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    ids.forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
  })();

  /* ── Productconfigurator (echte varianten + native bestellen) ── */
  (function () {
    var optColors = document.getElementById('optColors');
    if (!optColors) return;
    var VARIANTS = window.BONTU_VARIANTS || {};
    var IMGS = window.BONTU_PRODUCT_IMGS || {};
    var first = optColors.querySelector('.opt.sel') || optColors.querySelector('.opt');
    var state = {
      color: first ? first.getAttribute('data-color') : '',
      colorLabel: first ? first.getAttribute('data-val') : '',
      seats: '4 Seats', seatsLabel: '4 Zitplaatsen',
      wheels: 'Sport Aero Wheels', wheelsLabel: 'Sport aero velgen'
    };
    var imgs = [], idx = 0;
    var main = document.getElementById('galMain'), thumbs = document.getElementById('galThumbs');
    var buy = document.getElementById('btnBuy');
    function fmt(cents) { return '€' + (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function variant() { return VARIANTS[state.color + '|' + state.wheels + '|' + state.seats]; }
    function sync() { [].forEach.call(thumbs.children, function (c, i) { c.classList.toggle('active', i === idx); }); }
    function buildGallery() {
      imgs = (IMGS[state.color] || []).slice();
      idx = 0; if (imgs[0]) main.src = imgs[0];
      thumbs.innerHTML = '';
      imgs.forEach(function (src, i) {
        var b = document.createElement('button'); b.className = 'gthumb' + (i === 0 ? ' active' : ''); b.type = 'button';
        var im = document.createElement('img'); im.src = src; im.loading = 'lazy'; im.alt = 'Bontu ' + state.colorLabel + ' foto ' + (i + 1);
        b.appendChild(im);
        b.addEventListener('click', function () { idx = i; main.src = imgs[i]; sync(); });
        thumbs.appendChild(b);
      });
      sync();
    }
    var gp = document.getElementById('galPrev'), gn = document.getElementById('galNext');
    if (gp) gp.addEventListener('click', function () { idx = (idx - 1 + imgs.length) % imgs.length; main.src = imgs[idx]; sync(); });
    if (gn) gn.addEventListener('click', function () { idx = (idx + 1) % imgs.length; main.src = imgs[idx]; sync(); });
    function updateTotal() {
      var v = variant();
      var tv = document.getElementById('totalVal'), vp = document.querySelector('.phead .vp b'), pb = document.getElementById('pbarPrice');
      if (v) {
        if (tv) tv.innerHTML = fmt(v.price);
        if (vp) vp.innerHTML = fmt(v.price);
        if (pb) pb.textContent = '€' + (v.price / 100).toLocaleString('nl-NL');
        window.__bentuVariantId = v.id;
        window.__bentuTotal = v.price / 100;
        // lease-iframe pas na de prijs-paint herbouwen (blokkeert de prijs-update niet)
        if (typeof window.__onPriceChange === 'function') { var _pr = v.price / 100; requestAnimationFrame(function () { window.__onPriceChange(_pr); }); }
        if (buy) { buy.disabled = !v.avail; buy.textContent = v.avail ? T('buy') : T('sold'); }
      } else if (buy) { buy.disabled = true; buy.textContent = T('unavail'); }
    }
    document.querySelectorAll('#optSeats .opt').forEach(function (o) {
      o.addEventListener('click', function () {
        document.querySelectorAll('#optSeats .opt').forEach(function (x) { x.classList.remove('sel'); }); o.classList.add('sel');
        state.seats = o.getAttribute('data-seats'); state.seatsLabel = o.getAttribute('data-val'); updateTotal();
      });
    });
    document.querySelectorAll('#optWheels .opt').forEach(function (o) {
      o.addEventListener('click', function () {
        document.querySelectorAll('#optWheels .opt').forEach(function (x) { x.classList.remove('sel'); }); o.classList.add('sel');
        state.wheels = o.getAttribute('data-wheels'); state.wheelsLabel = o.getAttribute('data-val'); updateTotal();
      });
    });
    document.querySelectorAll('#optColors .opt').forEach(function (o) {
      o.addEventListener('click', function () {
        document.querySelectorAll('#optColors .opt').forEach(function (x) { x.classList.remove('sel'); }); o.classList.add('sel');
        state.color = o.getAttribute('data-color'); state.colorLabel = o.getAttribute('data-val');
        updateTotal(); requestAnimationFrame(buildGallery); // prijs direct, galerij in de volgende frame
      });
    });
    if (buy) buy.addEventListener('click', function () {
      var v = variant(); if (!v || !v.avail) return;
      buy.disabled = true; buy.textContent = 'Bezig...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart/' + v.id + ':1'; });
    });
    window.__bentuConfig = function () {
      var v = variant();
      return 'Bontu Microcar - ' + state.colorLabel + ', ' + state.seatsLabel + ', ' + state.wheelsLabel + (v ? ' - ' + fmt(v.price) : '');
    };
    buildGallery(); updateTotal();
  })();

  /* ── Leasen & Financieren (Bekaro-calculator) — alleen op productpagina ── */
  (function () {
    var lease = document.getElementById('leaseSection'), toggle = document.getElementById('leaseToggle');
    if (!lease) return;
    var loaded = false, lastPrice = 0;
    var CALC = 'https://bereken.bekarolease.nl/calculator/a11dc80f-7348-44d5-9e4b-8178fc42b614';
    function loadCalc(price) {
      price = price || window.__bentuTotal || 14295;
      if (loaded && price === lastPrice) return;
      lastPrice = price;
      var c = document.getElementById('lease-calculator'); if (!c) return;
      var exTax = Math.round(price / 1.21);
      var params = new URLSearchParams({ principal: price, 'principal-no-tax': exTax, 'tax-or-marge': 'btw', url: location.href, 'object-title': 'Bontu Microcar' });
      var f = document.createElement('iframe');
      f.src = CALC + '?' + params.toString(); f.width = '100%'; f.height = '640'; f.setAttribute('title', 'Leasen en financieren calculator');
      c.innerHTML = ''; c.appendChild(f); loaded = true;
    }
    if (toggle) toggle.addEventListener('click', function () {
      var isOpen = lease.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) loadCalc();
    });
    document.querySelectorAll('[data-openlease]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!lease.classList.contains('open')) { lease.classList.add('open'); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
        loadCalc(); lease.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    window.__onPriceChange = function (t) { if (loaded && lease.classList.contains('open')) loadCalc(t); };
  })();

  /* ── Contactpagina-formulier (inline succes, geen bedankt-redirect) ── */
  (function () {
    var f = document.getElementById('formContactPage'); if (!f) return;
    var msg = document.getElementById('cmsgPage'), btn = f.querySelector('button');
    f.addEventListener('submit', function (e) {
      e.preventDefault(); msg.className = 'cmsg'; msg.textContent = '';
      var fd = new FormData(f);
      if ((fd.get('company') || '').trim()) return;
      var name = (fd.get('name') || '').trim(), email = (fd.get('email') || '').trim();
      if (!name || !email) { msg.className = 'cmsg err'; msg.textContent = T('fillName'); return; }
      btn.disabled = true; var t = btn.textContent; btn.textContent = T('send');
      // lead-handler: captcha-check + centrale inbox (info@bontu.nl + m.heilygers) + klant-bevestiging
      sendLead(f, { type: 'contact', name: name, email: email, phone: (fd.get('phone') || '').trim(), message: (fd.get('message') || '').trim() })
        .then(function () { msg.className = 'cmsg'; msg.textContent = T('contactThanks'); f.reset(); resetCaptcha(f); })
        .catch(function (err) { msg.className = 'cmsg err'; msg.textContent = (err && err.message !== 'http') ? T('captchaFail') : T('error'); resetCaptcha(f); })
        .finally(function () { btn.disabled = false; btn.textContent = t; });
    });
    addCaptcha(f);
  })();

  /* ── Beelden voorladen na page-load (popups + productkleuren openen direct) ── */
  (function () {
    function warm(url) { if (url) { var p = new Image(); p.src = url; } }
    function warmAll() {
      document.querySelectorAll('.imodal img').forEach(function (im) { warm(im.getAttribute('src')); });
      var pi = window.BONTU_PRODUCT_IMGS || {};
      Object.keys(pi).forEach(function (k) { (pi[k] || []).forEach(warm); });
    }
    var ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 300); };
    if (document.readyState === 'complete') ric(warmAll);
    else window.addEventListener('load', function () { ric(warmAll); });
  })();

})();
